/**
 * IMPORTS
 */

import { searchSpnmentRepository } from "@/repositories/search-shipment";

/**
 * Função que busca remessas 🛠️.
 */
const handleGetSearchSpnment = async (
  accessToken: string,
  currentPage: number,
  itemsPerPage: number,
  searchItem: string
) => {
  try {
    const data = await searchSpnmentRepository.getAllSearchShipment(
      accessToken,
      currentPage,
      itemsPerPage,
      searchItem
    );

    return data;
  } catch (error: unknown) {
    if (error instanceof Error) {
      throw error; // ou retorne uma estrutura com erro formatado
    }

    throw new Error("Erro desconhecido em buscar remessas");
  }
};

/**
 * EXPORTS
 */
export { handleGetSearchSpnment };
